exports.base_url = "rsbcihi.afyachat.net/r/";
exports.org = "rsbcihi";
exports.env = "staging";
